import apps from "@services/applications";

export default [
  {
    path: "/app/work-manager",
    name: "work-manager",
    meta: {
      module: "work-manager",
      application: apps.Modules.WorkManager.Id,
      title: apps.Modules.WorkManager.Name,
      licenseName: "WorkManager"
    },
    component: () => import("@WorkManager/views/WorkManager.vue"),
    children: [
      {
        path: "task-item/:id",
        name: "task-item",
        meta: {
          authenticatedRoute: true
        },
        component: () => import("@WorkManager/components/TaskItemDetails.vue"),
        children: []
      }
    ]
  },
  {
    path: "/app/my-tasks",
    name: "my-tasks",
    meta: {
      module: "work-manager",
      application: apps.Modules.WorkManager.Id,
      title: apps.Modules.WorkManager.Name
    },
    component: () => import("@WorkManager/views/WorkManager.vue"),
    children: [
      {
        path: "task-item/:id",
        name: "my-task-item",
        meta: {
          authenticatedRoute: true
        },
        component: () => import("@WorkManager/components/TaskItemDetails.vue"),
        children: []
      }
    ]
  }
];
